// removed by extract-text-webpack-plugin
module.exports = {"ContentByCategory":"ContentByCategory__ContentByCategory__1rlkS","group":"ContentByCategory__group__37Gq5","title":"ContentByCategory__title__CE9hg","sliderContainer":"ContentByCategory__sliderContainer__2MvTE","wantMoreMessage":"ContentByCategory__wantMoreMessage__3YC6l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentByCategory/ContentByCategory.scss
// module id = 317
// module chunks = 0